import { authLeaderboard } from './index';

/**
 * get all leaderboards by id partner
 * @param {Object} opts - object: {String} partnerId - id partner, {String} currency - user currency
 */
export function getLeaderboardListApi(opts) {
  const url = `/ratings?partnerId=${opts.partnerId}&currency=${opts.currency}`;

  return authLeaderboard.get(url);
}

/**
 * get data leaderboard by id
 * @param {Object} opts - object: {String} tournamentId - tournament id, {String} currency - user currency
 */
export function getLeaderboardByIdApi(opts) {
  const url = `/ratings/one/${opts.tournamentId}?currency=${opts.currency}`;

  return authLeaderboard.get(url);
}

/**
 * join participant by leaderboardId ID
 * @param {String} tournamentId - tournament id
 */
export function setUserByIdApi(tournamentId) {
  const url = `/ratings/join/${tournamentId}`;

  return authLeaderboard.post(url);
}
